import { misc } from '@otto-ec/global-resources/misc';
import { type Action, type Feature, type MiniAction, tracking } from '@otto-ec/tracking-bct';
import { type KnownTrackingLabels, type TrackingLabels, convertLabelsToDataContainer } from './TrackingLabels';

/**
 *
 *
 *
 */
export interface TrackingGateway {
    submitEvent(labels: KnownTrackingLabels): void;
    addToPageImpression(labels: TrackingLabels, features?: Feature[]): void;
    trackOnNextPageImpression(labels: TrackingLabels): void;
    submitAction(labels: KnownTrackingLabels, action: Action): void;
    submitMiniActions(miniActions: MiniAction[]): void;
    getPageMergeId(): Promise<string>;
    replaceContext(contextId: string, url: string): Promise<void>;
}

/**
 *
 *
 */
class Tracking implements TrackingGateway {
    submitEvent(labels: KnownTrackingLabels): void {
        tracking.submitEvent(convertLabelsToDataContainer(labels));
    }

    addToPageImpression(labels: TrackingLabels, features?: Feature[]): void {
        tracking.submitMerge(convertLabelsToDataContainer(labels), features);
    }

    trackOnNextPageImpression(labels: TrackingLabels): void {
        tracking.trackOnNextPageImpression(convertLabelsToDataContainer(labels));
    }

    submitAction(labels: KnownTrackingLabels, action: Action): void {
        tracking.submitEvent(convertLabelsToDataContainer(labels), action);
    }

    submitMiniActions(miniActions: MiniAction[]): void {
        tracking.submitMiniAction(miniActions);
    }

    async getPageMergeId(): Promise<string> {
        return tracking.getPageMergeId().then((mergeId) => mergeId ?? misc.guid());
    }

    async replaceContext(contextId: string, url: string): Promise<void> {
        await tracking.replaceContext(contextId, url, {});
    }
}

export default new Tracking();
